var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Plane") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3896 6.07241L10.5266 4.08489V2.49688C10.5266 1.1186 9.40588 0 8.02502 0C6.64415 0 5.52345 1.1186 5.52345 2.49688V4.07491L0.620388 6.07241C0.24015 6.22222 0 6.59176 0 7.00125V8.99875C0 9.54807 0.450281 9.9975 1.00063 9.9975H5.52345V11.2559L3.15197 12.1248C2.76173 12.2647 2.49156 12.6442 2.49156 13.0637V14.0025C2.49156 14.5518 2.94184 15.0012 3.49218 15.0012H5.51345C5.51345 15.5506 5.96373 16 6.51407 16H9.51595C10.0663 16 10.5166 15.5506 10.5166 15.0012H12.5078C13.0582 15.0012 13.5084 14.5518 13.5084 14.0025V13.0637C13.5084 12.6442 13.2483 12.2747 12.848 12.1248L10.5166 11.2659V9.9975H14.9994C15.5497 9.9975 16 9.54807 16 8.99875V7.00125C16 6.59176 15.7498 6.23221 15.3796 6.07241H15.3896ZM2.00125 8V7.67041L5.52345 6.23221V7.99001H2.00125V8ZM7.5247 13.9925V2.50687C7.5247 2.22722 7.74484 2.00749 8.02502 2.00749C8.30519 2.00749 8.52533 2.22722 8.52533 2.50687V11.8652C8.52533 11.9351 8.52533 12.005 8.52533 12.0849V13.9925H7.5247ZM14.0088 8H10.5266V6.25218L14.0088 7.67041V8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/Plane.11264b50c53e84d6254ffa33522da79c.svg";
export { ForwardRef as ReactComponent };